import React, {Component} from 'react';
import styled from "styled-components";
import PropTypes from 'prop-types';

const ContentWrapper = styled.div`
    display: inline-block;
    vertical-align: top;
    margin: 0;
`;

const GenericButton = styled.button`
    padding: 0.15rem 0.25rem;
    margin-left: 0.25rem;
    vertical-align: top;
    cursor: pointer;
`;

const EditingValue = styled.textarea`
    display: inline-block;
    font-family: Courier;
    font-weight: bold;
    padding: 0.5rem;
    font-size: 1.25rem;
`;

const TextLength = styled.span`
    display: inline-block;
    font-family: Courier;
    font-weight: bold;
    font-size: 1rem;
    vertical-align: top;
    margin-left: 0.5rem;
    color: #555555;
`;

export class InputTextareaBar extends Component {

    static propTypes = {
        callback_ok: PropTypes.func.isRequired,
        callback_cancel: PropTypes.func.isRequired,
        initial_value: PropTypes.string,
        rows: PropTypes.number,
        cols: PropTypes.number
    }

    state = {
        value: this.props.initial_value ? this.props.initial_value : '',
        rows: this.props.rows ? this.props.rows : 5,
        cols: this.props.cols ? this.props.cols : 50,
        textarea_item_ref: React.createRef()
    };

    componentDidMount() {
        if (this.state.textarea_item_ref.current) {
            this.state.textarea_item_ref.current.focus();
        }
    }

    change_text(e) {
        this.setState({value: e.target.value});
    }

    render() {
        const {rows, cols, value, textarea_item_ref} = this.state;

        return <ContentWrapper>
            <EditingValue
                type={"textarea"}
                rows={rows}
                cols={cols}
                value={value}
                ref={textarea_item_ref}
                onChange={e => this.change_text(e)}/>
            <GenericButton
                onClick={e => this.props.callback_ok(value)}>
                ok
            </GenericButton>
            <GenericButton
                onClick={e => this.props.callback_cancel()}>
                cancel
            </GenericButton>
            <TextLength>{value.length}</TextLength>
        </ContentWrapper>
    }
}

export default InputTextareaBar;

